import React from 'react';
import { CheckIcon, ClockIcon } from 'lucide-react';
import { useStudio } from '../../contexts/StudioContext';
import { Draft } from '../../types/booking';
import { duration, euro } from '../../utils/format';
type Props = {
  draft: Draft;
  onChange: (patch: Partial<Draft>) => void;
};
export function StepService({
  draft,
  onChange
}: Props) {
  const {
    services,
    extras
  } = useStudio();
  const toggleExtra = (id: string) => onChange({
    extraIds: draft.extraIds.includes(id) ? draft.extraIds.filter(x => x !== id) : [...draft.extraIds, id]
  });
  return <div data-id="element-453" data-mp="2ahypzrzmykh0">
      <div className="space-y-3" data-id="element-454" data-mp="2ah6usi9yaor9">
        {services.filter(s => s.active).map(service => {
        const selected = draft.serviceId === service.id;
        return <button key={service.id} type="button" aria-pressed={selected} onClick={() => onChange({
          serviceId: service.id
        })} className={`flex w-full items-start gap-4 rounded-2xl border p-4 text-left transition-colors duration-200 ease-smooth sm:items-center sm:gap-5 ${selected ? 'border-ember bg-panel' : 'border-edge bg-carbon hover:border-ember/40'}`} data-id="element-455" data-mp="2jj6an798bmsm">
                <img src={service.image} alt="" aria-hidden="true" className="hidden h-24 w-32 shrink-0 rounded-xl object-cover sm:block" data-id="element-456" data-mp="1ublr2pfx1s9f" />
                <span className="flex-1" data-id="element-457" data-mp="2n12h5gg2cx2h">
                  <span className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1" data-id="element-458" data-mp="2i919y8xr5wjb">
                    <span className="font-display text-lg font-extrabold tracking-tight text-chalk sm:text-xl" data-id="element-459" data-mp="2d9y3ql61dk9r">
                      {service.name}
                    </span>
                    <span className="font-display text-lg font-extrabold text-chalk sm:text-xl" data-id="element-460" data-mp="3aqn56dr2qkim">
                      vanaf {euro(service.price)}
                    </span>
                  </span>
                  <span className="mt-1.5 block text-sm leading-relaxed text-dim" data-id="element-461" data-mp="141v2zvjewyi0">{service.summary}</span>
                  <span className="mt-2.5 flex items-center gap-1.5 text-xs uppercase tracking-[0.14em] text-dim" data-id="element-462" data-mp="184rfr5m9u0e1">
                    <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-463" data-mp="zad3zd0y97zo" />
                    {duration(service.durationMinutes)} in de werkplaats
                  </span>
                </span>
              </button>;
      })}
      </div>

      <h3 className="mt-10 text-xs uppercase tracking-[0.2em] text-dim" data-id="element-464" data-mp="pcyp3huocr9h">Extra's (optioneel)</h3>
      <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-3" data-id="element-465" data-mp="bdpk7ebx5jkt">
        {extras.filter(e => e.active).map(extra => {
        const selected = draft.extraIds.includes(extra.id);
        return <button key={extra.id} type="button" aria-pressed={selected} onClick={() => toggleExtra(extra.id)} className={`rounded-2xl border p-4 text-left transition-colors duration-200 ease-smooth ${selected ? 'border-ember bg-panel' : 'border-edge bg-carbon hover:border-ember/40'}`} data-id="element-466" data-mp="25ochgt6mq1ei">
                <span className="flex items-center justify-between gap-3" data-id="element-467" data-mp="2ovag1r0k1t0k">
                  <span className="font-medium text-chalk" data-id="element-468" data-mp="2osxruw47emf2">{extra.name}</span>
                  <span className={`flex h-5 w-5 items-center justify-center rounded-full border ${selected ? 'border-ember bg-ember text-void' : 'border-edge text-transparent'}`} aria-hidden="true" data-id="element-469" data-mp="33iddjxovo1nw">
                    <CheckIcon className="h-3 w-3" data-id="element-470" data-mp="38jsy7on5865r" />
                  </span>
                </span>
                <span className="mt-1.5 block text-xs text-dim" data-id="element-471" data-mp="1i6vhjwx45ra2">{extra.note}</span>
                <span className="mt-3 block text-sm font-semibold text-ember" data-id="element-472" data-mp="1e6bi2mp2ibkr">
                  + {euro(extra.price)} · {duration(extra.durationMinutes)}
                </span>
              </button>;
      })}
      </div>
    </div>;
}